/**
 * @param marketoFormContainer {HTMLElement}
 * @return {void}
 */
module.exports = function removeMarketoFormEmbed(marketoFormContainer) {
    marketoFormContainer.remove();
}